<template>
    <v-dialog v-if="chart && chart.data && chart.data.length > 1" v-model="dialog" >
        <v-card>
            <v-card-title>
                Page Load Performance
            </v-card-title>
            <v-card-text>
                <GChart type="Timeline" :data="chart.data" :options="chart.options" :settings="chart.settings" />
                <div class='summary'>{{ chart.data.length }} Requests totalling {{chart.stats.responseSize}} bytes in {{chart.stats.time}} ms</div>
                <v-btn text @click="dialog = false" outlined dark color="primary">Close</v-btn>
            </v-card-text>
        </v-card>
    </v-dialog>
    <div v-else>
        Waiting for data
    </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
    name: "HarViewer",
    components: { GChart },
    props: ['hardata', 'options'],
    data () {
        return {
            dialog: true
        }
    },
    computed: {
        chart: function () {
            console.log('hardata', this.hardata);
            console.log('breakpoint', this.$vuetify.breakpoint);
            let out = [
                [
                    {type: "string", id:"URL"},
                    {type: "string", id: "Bar label"},
                    {type: "string", role:"tooltip"},
                    { type: 'date', id: 'Start' },
                    { type: 'date', id: 'End' }
                ]
            ];

            let pages = this.hardata && this.hardata.log && this.hardata.log.entries;
            let responseSize = 0;

            if(pages && pages.length){

                for(let i in pages){
                    if(!pages[i].request) continue;
                    let url = pages[i].request.url.substring(0,40);
                    if(pages[i].request.url.length > 40) url += "...";
                    let barlabel = pages[i].response.status + " " + pages[i].response.statusText + " " + pages[i].time + " ms";

                    let tooltip = "<div style='padding:1rem;'>";
                        tooltip += "<div><label style='width:100px;display:inline-block;'>Method:</label> <span >" + pages[i].request.method + "</span></div>";
                        tooltip += "<div style='white-space: nowrap'><label style='width:100px;display:inline-block;'>URL:</label> <span style='white-space: nowrap'>" + url + "</span></div>";
                        tooltip += "<div><label style='width:100px;display:inline-block;'>HTTP Version:</label> <span>"+ pages[i].response.httpVersion + "</span></div>";
                        tooltip += "<div><label style='width:100px;display:inline-block;'>Mime Type:</label> <span>"+ pages[i].response.content.mimeType + "</span></div>";
                    for(let k in pages[i].response.headers){
                        tooltip += "<div><label style='width:100px;display:inline-block;'>" + pages[i].response.headers[k].name + ":</label> <span>"+ pages[i].response.headers[k].value + "</span></div>";
                    }
                    tooltip += "</div>";

                    let startts = new Date(pages[i].startedDateTime).valueOf();
                    responseSize += pages[i].response.bodySize;
                    out.push([
                        pages[i].request.url,
                        barlabel,
                        tooltip,
                        new Date(pages[i].startedDateTime),
                        new Date(startts + pages[i].time)
                    ])
                }
            }
            let height = out.length * 16;
            let width = this.$vuetify.breakpoint.width * .90;
            let stats = {
                time: this.hardata.runtime,
                responseSize: responseSize
            }
            // if(width < 700) width = this.$vuetify.breakpoint.width * .96;
            // if(height > 700) height=700;
            return {
                data: out,
                options: { tooltip: { isHtml: true }, width: width, height: height },
                settings: { packages: ['timeline'] },
                stats: stats
            };
        }
    }
}
</script>

<style scoped>
.summary {
    margin-bottom: 1rem;
}
/* .pftip {
    padding: 1rem;
}
.pftip label {
    width: 100px;
} */
</style>

